// Modern Form 0781 content moved to `form0781/content` so `all-claims`
// and `all-claims-v2` share one definition. Re-exported for existing imports.
export * from '../../form0781/content';
